var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"tw-text-gray-800 tw-flex tw-items-center"},[_c('money-format',{attrs:{"value":_vm.event.amount,"locale":_vm.locale,"subunits-value":""}}),_vm._v(" "+_vm._s(_vm.event.type))],1),_c('div',{staticClass:"tw-mt-0.5 tw-text-xs tw-text-gray-500"},[_vm._v("\n    "+_vm._s(_vm.event.label)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }